var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18764 13.998L6.34863 8.95603C6.37462 8.89519 6.38514 8.82885 6.37923 8.76295C6.37332 8.69705 6.35118 8.63364 6.31479 8.57839C6.27839 8.52313 6.22887 8.47775 6.17066 8.44631C6.11244 8.41486 6.04734 8.39833 5.98118 8.39819H4.40097C4.33459 8.39844 4.2692 8.38215 4.2107 8.35078C4.1522 8.31942 4.10244 8.27397 4.06592 8.21855C4.02939 8.16312 4.00725 8.09947 4.0015 8.03335C3.99575 7.96722 4.00657 7.9007 4.03298 7.83981L6.4809 2.23999C6.51201 2.16869 6.56325 2.10802 6.62832 2.06539C6.6934 2.02276 6.76949 2.00004 6.84728 2H10.9538C11.0292 2.00003 11.103 2.02134 11.1668 2.06149C11.2305 2.10164 11.2817 2.15899 11.3143 2.22693C11.3469 2.29487 11.3596 2.37064 11.3511 2.44551C11.3425 2.52038 11.3129 2.5913 11.2658 2.65011L9.10588 5.35029C9.05888 5.40914 9.02946 5.48006 9.02099 5.55489C9.01252 5.62972 9.02534 5.70543 9.058 5.77329C9.09065 5.84116 9.14179 5.89843 9.20555 5.93851C9.26931 5.97859 9.34309 5.99986 9.4184 5.99987H11.2221C11.3012 5.99983 11.3786 6.02329 11.4445 6.06727C11.5103 6.11125 11.5616 6.17378 11.5919 6.24693C11.6221 6.32009 11.63 6.40058 11.6145 6.47821C11.599 6.55585 11.5608 6.62713 11.5047 6.68304L4.18764 13.998Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconFlash);
export default __webpack_public_path__ + "static/media/streamline-icon-flash.04d6a32750d4daed271e0e62f0ed88a3.svg";
export { ForwardRef as ReactComponent };